import type { GuestbookMessage } from "@/models"
import { axios } from "@/axios"
import { GuestbookMessageType } from "@/models"

export async function deleteGuestbookMessage(message: GuestbookMessage, eventVaultId?: number) {
  if (!eventVaultId) {
    throw new Error("Call to \"deleteGuestbookMessage\" requires an event vault id.")
  }

  if (!message?.id) {
    throw new Error("Call to \"deleteGuestbookMessage\" requires a message id.")
  }

  const queryParams = new URLSearchParams()

  if (message.type === GuestbookMessageType.Video) {
    queryParams.append("type", "1") // 1 = MessageType.Video in EventVaultModels.cs
  }

  return axios.delete(`api/${eventVaultId}/messages/${message.id}?${queryParams.toString()}`)
}
